import React, { useEffect, useMemo, useState } from 'react'
import SlideOverHelpPanel, { HelpFooterNote } from '../../pages/compliance-safe/components/SlideOverHelpPanel'
import { useScreenHelp } from '../../hooks/useScreenHelp'

export default function ScreenHelpPanel({
  screenKey,
  open,
  onClose,
  focusSectionId = 'overview',
  sectionIdPrefix = 'screen-help',
}) {
  const { data, loading } = useScreenHelp(screenKey)
  const [forceOpen, setForceOpen] = useState(false)
  const isOpen = Boolean(open || forceOpen)

  useEffect(() => {
    const onArchieOpen = () => setForceOpen(true)
    window.addEventListener('psg:open-screen-help', onArchieOpen)
    return () => window.removeEventListener('psg:open-screen-help', onArchieOpen)
  }, [])

  const sections = useMemo(() => {
    if (!data?.sections) return []
    return data.sections.map((s) => ({
      id: s.section_key,
      title: s.title,
      blocks: s.blocks,
    }))
  }, [data])

  const footer = data?.legal_footer?.text ? (
    <HelpFooterNote>
      <span className="text-slate-700">{data.legal_footer.text}</span>
    </HelpFooterNote>
  ) : null

  if (!isOpen || loading || !data) return null

  const handleClose = () => {
    setForceOpen(false)
    onClose?.()
  }

  return (
    <SlideOverHelpPanel
      open={isOpen}
      onClose={handleClose}
      title={data.title || 'Help'}
      subtitle={data.subtitle || ''}
      sections={sections}
      focusSectionId={focusSectionId}
      sectionIdPrefix={sectionIdPrefix}
      footer={footer}
    />
  )
}
